import { resolveOperationalPresenceFeatureFlags } from './operationalPresenceFeatureFlags.js';

// Mesmo padrao de cameraRuntime.js: le a flag do ambiente Vite (import.meta.env)
// uma unica vez no boot do bundle. Nao le nenhum segredo — apenas o
// booleano deny-by-default.
export const operationalPresenceFeatureFlags = resolveOperationalPresenceFeatureFlags({
  OPERATIONAL_PRESENCE_ENABLED:
    import.meta.env.VITE_OPERATIONAL_PRESENCE_ENABLED
    || import.meta.env.OPERATIONAL_PRESENCE_ENABLED,
});

export const isOperationalPresenceEnabled = () => operationalPresenceFeatureFlags.OPERATIONAL_PRESENCE_ENABLED;

export default { operationalPresenceFeatureFlags, isOperationalPresenceEnabled };
